import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FaultedInvoiceModel } from "@app/core/models/invoices/faulted-invoice.model";
import { AdminService } from "@app/core/services/admin.service";
import { FileDownloadService } from "@app/core/services/filedownload.service";
import { ModalComponent } from "@app/shared/components/modal/modal.component";
import { ModalHelper } from "@app/shared/models/modal-helper.model";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-faulted-invoice-detail',
    templateUrl: './faulted-invoice-detail.component.html',
    styleUrls: ['./faulted-invoice-detail.component.scss']
})
export class FaultedInvoiceDetailDetailComponent implements OnInit, OnDestroy {

    faultedInvoice: FaultedInvoiceModel;
    unsubscribe$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private dialogRef: MatDialogRef<FaultedInvoiceDetailDetailComponent>,
        public dialog: MatDialog,
        private adminService: AdminService,
        private fileDownloadService: FileDownloadService,
        @Inject(MAT_DIALOG_DATA) data) {
        this.faultedInvoice = data.FaultedInvoice;
    }

    ngOnInit(): void {

    }

    onDownload = () => {
        this.adminService.getAttachmentContent(this.faultedInvoice.Id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((blobData: Blob) => {
                this.fileDownloadService.downloadBlob(blobData, this.faultedInvoice.DocumentFileName);
            }, (_) => {
                const modalErreurConfig = new ModalHelper().getAlertConfig(`Une erreur est survenue lors du téléchargement.`);
                this.dialog.open(ModalComponent, modalErreurConfig);
            });
    }

    onClose() {
        this.dialogRef.close();
    }


    ngOnDestroy() {
        this.unsubscribe$.next(true);
    }
}